export default "__VITE_ASSET__HQNe14Tr__"